import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from 'body-scroll-lock';

import Logo from 'img/logo.png';

import {
  toggleLeaderboard,
  closeLeaderboard,
} from '_redux/actioncreators/leaderboard';
import { PAGE_TYPES } from '_enums/page-types';
import { prefetchPageContent } from '_redux/actioncreators/page';
import { Translate } from '_translations';
import Picture from '../general/Picture';
import LanguageSelector from './LanguageSelector';

class Navigation extends Component {
  constructor() {
    super();

    this.state = {
      navigationOpen: false,
    };

    this.mobileNavigation = React.createRef();
  }

  render() {
    if (this.props.navigation.contentLoading === true) {
      return null;
    }

    return (
      <React.Fragment>
        <nav
          className={`navigation ${this.state.navigationOpen ? 'active' : ''}`}
        >
          <ul>
            {this.props.navigation.content.navigationItems.map(this.renderLink)}
          </ul>
        </nav>

        <nav className="mobile-navigation" ref={this.mobileNavigation}>
          <div className="mobile-navigation--inner">
            <div
              className={`menu-toggle ${
                this.state.navigationOpen ? 'active' : ''
              }`}
              onClick={this.toggleNavigation}
            >
              <div className="menu-icon" />
              <Translate resourceString="Thunderbolt.Menu" />
            </div>
            <div
              className={`leaderboard-toggle ${
                this.props.leaderboard.isOpen ? 'active' : ''
              }`}
              onClick={this.handleLeaderboardClick}
            >
              <Translate resourceString="Thunderbolt.Leaderboard" />
              <div className="leaderboard-icon" />
            </div>
          </div>
        </nav>
      </React.Fragment>
    );
  }

  // eslint-disable-next-line
  renderLink = (item, index) => {
    // Used to render the logo for the homepage, hence the "/"
    if (item.slug === '/') {
      return (
        <li key={index}>
          <Link
            key={index}
            to={`/${this.props.culture.alias}${item.slug}`}
            onClick={this.handleNavigationClick}
            onMouseOver={() =>
              this.props.prefetchPageContent(
                this.props.culture.cultureCode,
                PAGE_TYPES.HOME,
              )
            }
          >
            <Picture>
              <source media="(min-width: 992px)" srcSet={Logo} />
              <img src={Logo} alt="Thunderbolt" />
            </Picture>
          </Link>
          <LanguageSelector
            cultureCode={this.props.culture.cultureCode}
            languages={this.props.cultures.content.cultureItems}
          />
        </li>
      );
    }

    return (
      <li key={index} className={this.getActiveClass(item.slug)}>
        <Link
          key={index}
          to={`/${this.props.culture.alias}${item.slug}`}
          onClick={this.handleNavigationClick}
          onMouseOver={() => this.props.prefetchPageContent(this.props.culture.cultureCode, item.contentClassName)}>
          {item.pageTitle}
        </Link>
      </li>
    );
  };

  componentWillUnmount() {
    clearAllBodyScrollLocks();
  }

  toggleNavigation = () => {
    this.props.closeLeaderboard();
    clearAllBodyScrollLocks();

    if (this.state.navigationOpen === true) {
      this.closeNavigation();
    } else {
      this.openNavigation();
    }
  };

  closeNavigation = () => {
    if (window.matchMedia('(max-width: 991px)').matches) {
      enableBodyScroll(this.mobileNavigation.current);
    }

    this.setState({
      navigationOpen: false,
    });
  };

  openNavigation = () => {
    if (window.matchMedia('(max-width: 991px)').matches) {
      disableBodyScroll(this.mobileNavigation.current);
    }

    this.setState({
      navigationOpen: true,
    });
  };

  handleLeaderboardClick = () => {
    this.closeNavigation();
    this.props.toggleLeaderboard(this.props.leaderboard.isOpen);
  };

  handleNavigationClick = () => {
    this.closeNavigation();

    window.scrollTo(0, 0);
  };

  getActiveClass = (slug) => {
    if (
      `/${this.props.culture.cultureAlias}${slug}` ===
      this.props.location.pathname
    ) {
      return 'active';
    } else if (
      `/${this.props.culture.cultureCode}${slug}` ===
      this.props.location.pathname
    ) {
      return 'active';
    }
    return null;
  };
}

const mapStateToProps = state => ({
  leaderboard: state.app.leaderboard,
  cultures: state.app.cultures,
});

const mapDispatchToProps = dispatch => ({
  toggleLeaderboard: isOpen => dispatch(toggleLeaderboard(isOpen)),
  closeLeaderboard: () => dispatch(closeLeaderboard()),
  prefetchPageContent: (cultureCode, contentClassName) =>
    dispatch(prefetchPageContent({ cultureCode, contentClassName })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(Navigation));
